import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from '../rootReducer'
import rootSaga from '../rootSaga'

// Removendo dependência do Reactotron
const sagaMiddleware = createSagaMiddleware()

// Simplificando o enhancer para não usar o Reactotron
const enhancer = process.env.NODE_ENV === 'development'
  ? composeWithDevTools(applyMiddleware(sagaMiddleware))
  : applyMiddleware(sagaMiddleware)

const store = createStore(
  rootReducer,
  enhancer
)

sagaMiddleware.run(rootSaga)

export default store
